import React from 'react';
import { AgGridReact } from 'ag-grid-react'
import { TableWrapper } from './Table.style';


const defaultColDef = {
  flex: 100,
  minWidth: 100,
  resizable: true,
  // filter: true,
  sortable: true,
  alwaysShowHorizontalScroll: true,
  suppressHorizontalScroll: false
};

class TableComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gridApi: {},
      selectedRow: {},
      showView: false
    }
  }
  onGridReady = (params) => {
    this.setState({
      gridApi: params.api
    })
  };

  onQuickFilterChanged = () => {
    this.state.gridApi.setQuickFilter(document.getElementById('quickFilter').value);
  };

  onSelectionChanged = () => {
    let rows = this.state.gridApi.getSelectedRows();
    this.setState({
      showView: true
    })

    if (rows && rows.length === 1) {
      this.setState({
        showView: false,
        selectedRow: rows[0]
      })

    }
  };

  render() {
    return (

      // <TableContainer className='table-container'>
      <TableWrapper>


        <div id="myGrid" className="ag-theme-alpine div.ag-row" style={{ width: '100%', height: this.props.height }}>

          <AgGridReact
            columnDefs={this.props.headings}
            headerHeight= "39"
            rowHeight = "39"
            defaultColDef={defaultColDef}
            rowData={this.props.data}
            onGridReady={this.onGridReady}
            pagination={true}
            paginationPageSize={30}
            onSelectionChanged={this.onSelectionChanged}
            onCellClicked={this.props.onCellClicked}
            onRowClicked={this.props.handleClick}            
            />
        </div>

            </TableWrapper>
      //  </TableContainer>

    )
  }
}

export default TableComponent;
